// Eventually benefits will come from the new API design, but for now, compute using a
// similar method that we used to use in the SPA.
import { Benefits } from ".";

type LevelMap = {
  [key: string]: Benefits;
};

export const hdc1Dot0BenefitsMap: LevelMap = {
  US1: { distance: 20 },
  CAN1: { distance: 30 },
  US2: { distance: 100 },
  CAN2: { distance: 80 },
  US3: { distance: 150 },
  CAN3: { distance: 200 },
  USVIP: { distance: 150 },
  CANVIP: { distance: 200 },
} as const;

export const getHdc1Dot0Benefits = (
  productCode: string
): Benefits | undefined => {
  const splitProductCodeIntoCountryAndLevel = /^(US|CAN)MEMB(HDC)?(.*)$/;
  const groups = splitProductCodeIntoCountryAndLevel.exec(productCode) || [];

  const [, country = "", , level = ""] = groups;
  const key = `${country}${level}`;
  const benefits = hdc1Dot0BenefitsMap[key];

  return benefits;
};
